import { styled, Typography } from "@material-ui/core";

export const TTTContainer = styled("div")(({ theme }) => ({
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
}));

export const TTTContentWrapper = styled("div")(({ theme }) => ({
  paddingBottom: theme.spacing(16),
  paddingTop: theme.spacing(8),
  padding: theme.spacing(4),
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  maxWidth: "1140px",
  display: "flex",
}));

export const TTTSectionText = styled(Typography)(({ theme, bold }) => ({
  marginBottom: theme.spacing(2),
  fontSize: theme.typography.body1.fontSize,
  color: theme.palette.secondary.main,
  ...(bold && { fontWeight: theme.typography.fontWeightBold }),
}));

export const TTTSectionTitle = styled(Typography)(({ theme, size }) => ({
  fontSize: theme.typography[size === "sm" ? "h5" : "h4"].fontSize,
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(2),
}));

export const TTTSectionSubTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.fontWeightBold,
}));

export const TTTElements = styled("div")(({ theme }) => ({
  marginBottom: theme.spacing(4),
  justifyContent: "center",
  alignItems: "stretch",
  display: "flex",

  "& > div:not(:last-child)": {
    marginRight: "1.5rem",
  },

  [`${theme.breakpoints.down("sm")}`]: {
    flexDirection: "column",

    "& > div:not(:last-child)": {
      marginBottom: "1.5rem",
      marginRight: 0,
    },
  },
}));



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitTraining/TeachersToolkitTraining.styled.js